import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { WinnersOnlyNotice } from "@/components/WinnersOnlyNotice";
import { Sparkles } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/collection");
    } catch (_) { /* ignore: errors surfaced via toast */ } finally { setSubmitting(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="hud-pill rounded-2xl p-8">
        <div className="flex items-center gap-2 mb-1">
          <Sparkles className="h-5 w-5 text-cyan-300" />
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-300">Access Vault</div>
        </div>
        <h1 className="font-display text-3xl text-white mt-2 tracking-[0.06em]">SIGN IN</h1>
        <p className="text-white/50 text-sm mt-1">Enter your credentials to access your collection.</p>

        <WinnersOnlyNotice variant="inline" className="mt-4" />

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email" className="text-white/70 text-xs uppercase tracking-[0.2em]">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 bg-[hsl(220_18%_12%)] border-white/10" />
          </div>
          <div>
            <Label htmlFor="password" className="text-white/70 text-xs uppercase tracking-[0.2em]">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 bg-[hsl(220_18%_12%)] border-white/10" />
          </div>
          <Button type="submit" data-testid="login-submit-button" disabled={submitting} className="w-full bg-cyan-400 text-black hover:bg-cyan-300">
            {submitting ? "Authenticating…" : "Enter Vault"}
          </Button>
        </form>

        <div className="text-center text-sm text-white/50 mt-6">
          No account yet? <Link to="/register" className="text-cyan-300 hover:text-cyan-200">Create one</Link>
        </div>
      </div>
    </div>
  );
}
